import { JobCardForm } from "@/pages/jobcards/types";

interface Props {
  form: JobCardForm;
}

export default function SectionCompanyProfile({ form }: Props) {
  return (
    <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
      <div className="px-5 py-3 bg-gray-50 border-b border-gray-100 flex items-center gap-2">
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-building-line text-amber-600 text-base" />
        </span>
        <h3 className="text-sm font-semibold text-gray-800">Section 1 — Company Profile</h3>
        <span className="ml-auto text-xs text-gray-400 bg-gray-100 px-2 py-0.5 rounded">Auto-filled from Settings</span>
      </div>
      <div className="p-5">
        <div className="flex items-center gap-4 p-4 bg-amber-50/50 rounded-xl border border-amber-100">
          <div className="w-14 h-14 rounded-xl bg-white border border-amber-100 flex items-center justify-center overflow-hidden flex-shrink-0">
            {form.companyLogo ? (
              <img src={form.companyLogo} alt="logo" className="w-11 h-11 object-contain" />
            ) : (
              <span className="w-6 h-6 flex items-center justify-center">
                <i className="ri-image-line text-xl text-gray-300" />
              </span>
            )}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-bold text-gray-900">{form.companyName || "—"}</p>
            <p className="text-xs text-gray-500 mt-0.5">{form.companyAddress || "—"}</p>
            <div className="flex items-center gap-3 mt-1 flex-wrap">
              {form.companyEmail && (
                <span className="text-xs text-gray-500 flex items-center gap-1">
                  <span className="w-3 h-3 flex items-center justify-center"><i className="ri-mail-line text-xs text-gray-400" /></span>
                  {form.companyEmail}
                </span>
              )}
              {form.companyPhone && (
                <span className="text-xs text-gray-500 flex items-center gap-1">
                  <span className="w-3 h-3 flex items-center justify-center"><i className="ri-phone-line text-xs text-gray-400" /></span>
                  {form.companyPhone}
                </span>
              )}
              {form.companyGstin && (
                <span className="text-xs text-gray-500 flex items-center gap-1">
                  <span className="w-3 h-3 flex items-center justify-center"><i className="ri-government-line text-xs text-gray-400" /></span>
                  GSTIN: {form.companyGstin}
                </span>
              )}
            </div>
          </div>
          <a href="/settings" className="text-xs text-amber-600 hover:underline whitespace-nowrap flex items-center gap-1 flex-shrink-0">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-settings-3-line text-xs" /></span>
            Edit in Settings
          </a>
        </div>
      </div>
    </div>
  );
}
